import { useUiStore } from '../hooks/ui.store'
import { languageName, useT } from '../i18n'

import type { LanguageSelectProps } from './LanguageSelect.types'

/**
 * Admin language switcher (ADR-043): the site languages from
 * `CONTENT_LOCALES`, each named in itself. The choice is kept per browser.
 */
export function LanguageSelect({
  locales,
  compact = false,
}: LanguageSelectProps) {
  const { locale, t } = useT()
  const setUiLocale = useUiStore((s) => s.setUiLocale)

  return (
    <label
      className={compact ? 'lang-select lang-select--compact' : 'lang-select'}
    >
      <span className={compact ? 'sr-only' : 'field__label'}>
        {t.shell.language}
      </span>
      <select
        className="control"
        value={locale}
        onChange={(e) => setUiLocale(e.target.value)}
        aria-label={compact ? t.shell.language : undefined}
      >
        {locales.map((l) => (
          <option key={l} value={l} lang={l}>
            {compact ? l.toUpperCase() : `${languageName(l)} (${l})`}
          </option>
        ))}
      </select>
    </label>
  )
}
